import React, { useContext, useState } from 'react'
import Login from '../components/Firebase/Auth/Login'
import RegisterForm from '../components/Firebase/Auth/Register'
import ResetPassword from '../components/Firebase/Auth/ResetPassword'
import StateContext from '../StateContext'

function AuthPage() {

    const appState = useContext(StateContext)

    const [mode, setMode] = useState("login")

    function toggleMode(modeObj) {
        console.log(mode, modeObj)
        if (mode !== modeObj) {
            setMode(modeObj)
            console.log(mode)
        }
    }


    return (
        <div className="intro-login">
            <div className="mask rgba-black-strong">
                <div className="container py-4">
                    <div className="col-md-8 col-lg-6 mx-auto">
                        <div className="card card-body card-transparent">
                            {appState.loggedIn ? (
                                <p className="text-white">Logget inn!</p>
                            ) 
                            : (
                                <>
                                    {mode === "login" && <Login />}
                                    {mode === "register" && <RegisterForm />}
                                    {mode === "reset" && <ResetPassword />}
                                    {mode === "login" || mode === "reset" && <button className="btn btn-transparent btn-block text-white" onClick={() => toggleMode("register")}>Register</button>}
                                    {mode === "register" || mode === "reset" && <button className="btn btn-block btn-transparent text-white" onClick={() => toggleMode("login")}>Logg inn</button>}
                                    {mode !== "reset" && <button className="btn btn-block btn-transparent text-white" onClick={() => toggleMode("reset")}>Glemt passord</button>}
                                </>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
export default AuthPage